export enum GoalStatus {
    DRAFT = 'DRAFT',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    DELETED = 'DELETED',
}

export enum GoalTaskStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    DELETED = 'DELETED',
}

export enum GoalCategory {
    MONEY_MANAGEMENT = 'Money Management',
    MILESTONES = 'Milestones',
    BUILDING_WEALTH = 'Building Wealth',
    FUNDAMENTALS = 'Fundamentals',
    LEGACY = 'Legacy',
}

export interface GoalTask {
    id: string;
    goalId: string;
    description: string;
    status: GoalTaskStatus;
    position: number;
    createdAt: string;
    updatedAt?: string;
}

export interface Goal {
    id: string;
    goalGroupId: string;
    description: string;
    status: GoalStatus;
    targetAmount?: number | null;
    targetDate?: string | null;
    position: number;
    createdAt: string;
    updatedAt?: string;
    tasks: GoalTask[];
}

export interface GoalGroup {
    id: string;
    goalCategoryId: string;
    membershipId: string;
    position: number;
    createdAt: string;
    updatedAt?: string;
    goals: Goal[];
}
